import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ReferenceDeviceMovementService } from 'app/services/models/reference-device-movement.service';
import { Turkish } from 'flatpickr/dist/l10n/tr';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-dialog-reference-device-movement',
  templateUrl: './dialog-reference-device-movement.component.html',
  styleUrls: ['./dialog-reference-device-movement.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DialogReferenceDeviceMovementComponent implements OnInit {
  @Input() data: { message: string, id: number, deviceId: number };

  referenceDeviceForm: FormGroup;

  date = new Date();
  date2: Date = new Date();


  public dateTimeStartOptions: FlatpickrOptions = {
    altInput: true,
    enableTime: true,
    dateFormat: 'd.m.Y',
    altFormat: 'd.m.Y',
    locale: Turkish,
    defaultDate: this.date
  };

  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private referenceDeviceService: ReferenceDeviceMovementService,
    private toastrService: ToastrService
  ) {
    this.date2.setFullYear(this.date2.getFullYear() + 1);
  }

  async ngOnInit() {
    this.referenceDeviceForm = this.fb.group({
      certificateNo: [null, [Validators.required, Validators.maxLength(20)]], // Tek firma seçimi
      calibrationDate: [null, Validators.required],
      futureCalibrationDate: [null, Validators.required],
      traceability: [null, Validators.required],
      acceptanceCriterion: [null, [Validators.required, Validators.maxLength(30)]],
      calibrationCertificateUncertainty: [null, [Validators.required, Validators.maxLength(30)]] // Birden fazla ürün formu
    });

    if (this.data.id) {
      await this.getByIdreferenceDevice(this.data.id);
    }

  }


  async getByIdreferenceDevice(id) {
    const data = await this.referenceDeviceService.getByIdReferenceDeviceMovement(id);
    console.log(data);
    this.date = new Date(data.calibrationDate);
    this.date2 = new Date(data.futureCalibrationDate);
    if (data) {
      this.referenceDeviceForm.patchValue({
        certificateNo: data.certificateNo,
        calibrationDate: data.calibrationDate,
        futureCalibrationDate: data.futureCalibrationDate,
        traceability: data.traceability,
        acceptanceCriterion: data.acceptanceCriterion,
        calibrationCertificateUncertainty: data.calibrationCertificateUncertainty
      });
    }
  }


  closeModal() {
    this.activeModal.close(false);
  }

  async onSumbit() {
    if (this.referenceDeviceForm.valid) {
      console.log(this.referenceDeviceForm.value);

      if (this.data.id) {
        const data = await this.referenceDeviceService.updateDeviceReferenceMovement({
          id: this.data.id,
          calibrationCertificateUncertainty: this.referenceDeviceForm.value.calibrationCertificateUncertainty,
          calibrationDate: this.referenceDeviceForm.value.calibrationDate[0],
          certificateNo: this.referenceDeviceForm.value.certificateNo,
          deviceId: this.data.deviceId,
          futureCalibrationDate: this.referenceDeviceForm.value.futureCalibrationDate[0],
          traceability: this.referenceDeviceForm.value.traceability,
          acceptanceCriterion: this.referenceDeviceForm.value.acceptanceCriterion
        });
        if (data.status) {
          this.referenceDeviceService.sendEvent(true);
          this.toastrService.success(data.message);
          this.closeModal();
        } else {
          this.toastrService.error(data.message);
        }
      } else {
        const data = await this.referenceDeviceService.createDeviceReferenceMovement({
          id: null,
          calibrationCertificateUncertainty: this.referenceDeviceForm.value.calibrationCertificateUncertainty,
          calibrationDate: this.referenceDeviceForm.value.calibrationDate[0],
          certificateNo: this.referenceDeviceForm.value.certificateNo,
          deviceId: this.data.deviceId,
          futureCalibrationDate: this.referenceDeviceForm.value.futureCalibrationDate[0],
          traceability: this.referenceDeviceForm.value.traceability,
          acceptanceCriterion: this.referenceDeviceForm.value.acceptanceCriterion
        });
        if (data.status) {
          this.referenceDeviceService.sendEvent(true);
          this.toastrService.success(data.message);
          this.closeModal();
        } else {
          this.toastrService.error(data.message);
        }
      }
    }
  }
}
